import gql from 'graphql-tag';

export default gql`
query checkForDuplicateSlug($slug: String!) {
  configAvailable(object: {subdomain: $slug}) {
    available
  }
}
`;
